import React from 'react'

import { useIntl } from 'react-intl'
import {
  Select,
  FormElement,
  FORM_ELEMENT_SPACING_SMALL
} from 'mailup-web-components'
import { useRecoilState, useRecoilValue } from 'recoil'
import { pageState } from 'Pages/EmailSendingWizard/recoil/state/page'
import { senderInfoState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'

const DynamicSenderName = () => {
  const intl = useIntl()
  const { dynamicOptions } = useRecoilValue(pageState)
  const [{ customNameValue }, setCustomName] = useRecoilState(senderInfoState)

  const handleChange = e => {
    const selectedOption = dynamicOptions.find(f => f.value === e)
    setCustomName(prev => ({
      ...prev,
      customNameValue: selectedOption.value,
      customNameLabel: selectedOption.label,
      savedAsDefault: undefined
    }))
  }

  return (
    <>
      <FormElement
        label={intl.formatMessage({
          id: 'Load.EmailSendingWizard.CustomSenderNameLabel'
        })}
        labelSpacing={FORM_ELEMENT_SPACING_SMALL}
      >
        <Select
          value={customNameValue}
          onChange={handleChange}
          placeholder={intl.formatMessage({
            id: 'Load.Filters.IdentifierPlaceholder'
          })}
          options={dynamicOptions}
        />
      </FormElement>
    </>
  )
}

export default DynamicSenderName
